/* eslint-disable @next/next/no-img-element */
import classNames from "classnames";
import { Arrow } from "@/components/ui/icons";

type LibrarySubGroupItemProps = {
  name: string;
  thumbnails: string[];
  onClick?: (val: string) => unknown;
};

export function LibrarySubGroupItem({
  name,
  thumbnails,
  onClick,
}: LibrarySubGroupItemProps) {
  const [topThumbnail, bottomThumbnail] = thumbnails;

  return (
    <div
      title={name}
      onClick={() => onClick?.(name)}
      className="cursor-pointer space-y-ds-2 group"
    >
      <div className="text-gray-400 flex items-center justify-between">
        <p
          data-testid="library-sub-group-display-name"
          className="text-md font-semibold leading-7 mr-4 whitespace-nowrap text-ellipsis overflow-hidden"
        >
          {name}
        </p>
        <Arrow
          className={`w-4 opacity-0 duration-300 shrink-0 group-hover:opacity-100`}
        />
      </div>
      <div className="relative">
        {topThumbnail && (
          <div
            className={classNames(
              "shadow-xl duration-200 z-0",
              "group-hover:scale-110 group-hover:-rotate-3",
              "group-hover:-translate-x-2 group-hover:translate-y-2"
            )}
          >
            <img
              data-testid="library-sub-group-primary-file"
              src={topThumbnail}
            />
          </div>
        )}
        {bottomThumbnail && (
          <div
            className={classNames(
              "shadow-lg duration-200 absolute top-0",
              "translate-x-2 translate-y-4 -z-10",
              "group-hover:rotate-1 group-hover:translate-x-4"
            )}
          >
            <img
              data-testid="library-sub-group-secondary-file"
              src={bottomThumbnail}
            />
          </div>
        )}
      </div>
    </div>
  );
}
